'use client'

import { useActionState, useId } from 'react'
import { Mail } from 'lucide-react'
import { Button, Field, Icon, Input, Pending } from '@/components/ui'
import { motDePasseOublie, type EtatFormulaire } from '../actions'
import { EnTeteVerre } from '../verre'

/**
 * Demande de réinitialisation.
 *
 * Rien de la logique n'a bougé : l'action serveur, le `name=`, le message
 * volontairement identique que l'adresse existe ou non. Seule la présentation
 * passe sur la carte de verre — ton sombre des champs, bouton `onInk`, titre
 * Playfair au mot accentué.
 *
 * ⚠️ Ce que la maquette porte en plus et qui n'est **pas** repris : le bloc
 * « Toujours bloqué — écrivez à Malorie ». Ce n'est pas de la présentation, c'est
 * du contenu neuf, avec un nom de personne et une promesse de traitement que
 * personne n'a validés. Il s'ajoutera le jour où quelqu'un l'écrira.
 */
export function FormulaireOubli() {
  const [etat, action, enCours] = useActionState<EtatFormulaire, FormData>(motDePasseOublie, {})
  const idEmail = useId()

  return (
    <form action={action} className="flex flex-col gap-5">
      <EnTeteVerre surtitre="Mot de passe oublié" titre="On vous renvoie un" accent="accès">
        Indiquez votre adresse : vous recevez un lien de réinitialisation valable une heure.
      </EnTeteVerre>

      <Field
        label="Adresse e-mail"
        htmlFor={idEmail}
        ton="fonce"
        error={etat.champ === 'email' ? etat.erreur : undefined}
      >
        <Input
          id={idEmail}
          name="email"
          type="email"
          required
          autoComplete="email"
          placeholder="vous@exemple.fr"
          invalid={etat.champ === 'email'}
          ton="fonce"
          icone={<Icon as={Mail} />}
        />
      </Field>

      <Button type="submit" variant="onInk" disabled={enCours} className="w-full">
        {enCours ? (
          <>
            <Pending label="Envoi en cours" /> Envoi…
          </>
        ) : (
          'Envoyer le lien'
        )}
      </Button>
    </form>
  )
}
